import React from 'react'
import { Card, Icon, Link } from 'sidecar-components'

export const GFEBubble = () => (
  <Card
    childrenClass="flex flex-row gap-x-4 items-center"
    className="mt-4"
    testId="info_goodFaithEstimate"
    sentiment="accent"
  >
    <Icon name="lightbulb" size="md" className="inherit" />
    <div>
      <p className="sh-strong mb-0">
        Don{'\u2019'}t have a provider quote yet?
      </p>
      <Link
        testId="link_accessingYourHealthPlan"
        path="/help/accessing-your-health-plan/good-faith-estimates-gfe"
        type="internal"
      >
        Get tips to getting an estimate.
      </Link>
    </div>
  </Card>
)
